import type { AxiosInstance } from 'axios';

export type CloudQueryClientRuntime = {
  axiosInstance: AxiosInstance;
  getOrganizationId: () => string | null;
};

let runtime: CloudQueryClientRuntime | undefined;

export const configureCloudQueryClient = (next: CloudQueryClientRuntime): void => {
  runtime = next;
};

export const getCloudQueryClientRuntime = (): CloudQueryClientRuntime => {
  if (!runtime) {
    throw new Error('CloudQuery client is not configured - call configureCloudQueryClient() during app bootstrap');
  }

  return runtime;
};
